// extracted by mini-css-extract-plugin
export var enLogoWall = "index-module--enLogoWall--x92ae";
export var enLogoWallImg = "index-module--enLogoWallImg--yNpDN";
export var logoWall = "index-module--logoWall--XZEfP";
export var move = "index-module--move--It0ds";
export var reverse = "index-module--reverse--TEYk7";
export var reversemove = "index-module--reversemove--p6kfX";
export var whiteBg = "index-module--whiteBg--obaWK";